import { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import StaffCanvasAccessBulkBar from './StaffCanvasAccessBulkBar';
import useStaffCanvasAccessBulkBarHook from './useStaffCanvasAccessBulkBarHook';

/**
 * Colocates bulk-bar state with the bulk bar UI and publishes APIs through the bridge.
 */
const StaffCanvasAccessBulkBarContainer = ({
  personId = null,
  staffName = null,
  locations,
  roleOptionsByLocation,
  loadRolesForLocation,
  refresh,
  onClearRowEdit,
  onSetSubmitting,
  onSetError,
  submitting,
  setBulkApi,
  visible = true,
}) => {
  const bulkApi = useStaffCanvasAccessBulkBarHook({
    personId,
    staffName,
    locations,
    roleOptionsByLocation,
    loadRolesForLocation,
    refresh,
    onClearRowEdit,
    onSetSubmitting,
    onSetError,
  });

  useLayoutEffect(() => {
    setBulkApi(bulkApi);
  }, [bulkApi, setBulkApi]);

  return (
    <StaffCanvasAccessBulkBar
      visible={visible}
      submitting={submitting}
      roleOptionsByLocation={roleOptionsByLocation}
      bulkSameRoleDraftId={bulkApi.bulkSameRoleDraftId}
      bulkRemoveConfirmMessage={bulkApi.bulkRemoveConfirmMessage}
      bulkRemoveOpen={bulkApi.bulkRemoveOpen}
      cancelBulk={bulkApi.cancelBulk}
      cancelBulkRemove={bulkApi.cancelBulkRemove}
      clearSelection={bulkApi.clearSelection}
      commonRoleIntersection={bulkApi.commonRoleIntersection}
      confirmBulkRemove={bulkApi.confirmBulkRemove}
      draftRoleByLocation={bulkApi.draftRoleByLocation}
      handleBulkDifferentRoleChange={bulkApi.handleBulkDifferentRoleChange}
      handleBulkSameRoleChange={bulkApi.handleBulkSameRoleChange}
      isBulkSaveDisabled={bulkApi.isBulkSaveDisabled}
      requestBulkRemove={bulkApi.requestBulkRemove}
      rolesLoading={bulkApi.rolesLoading}
      saveBulk={bulkApi.saveBulk}
      selectedLocationKeys={bulkApi.selectedLocationKeys}
      selectedRows={bulkApi.selectedRows}
      showBulkRemoveAction={bulkApi.showBulkRemoveAction}
      showDifferentRolesPanel={bulkApi.showDifferentRolesPanel}
      showSameRolePanel={bulkApi.showSameRolePanel}
      showSelectionBar={bulkApi.showSelectionBar}
      startBulkDifferentRoles={bulkApi.startBulkDifferentRoles}
      startBulkSameRole={bulkApi.startBulkSameRole}
    />
  );
};

StaffCanvasAccessBulkBarContainer.propTypes = {
  personId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  staffName: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  roleOptionsByLocation: PropTypes.object.isRequired,
  loadRolesForLocation: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  onClearRowEdit: PropTypes.func.isRequired,
  onSetSubmitting: PropTypes.func.isRequired,
  onSetError: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  setBulkApi: PropTypes.func.isRequired,
  visible: PropTypes.bool,
};

export default StaffCanvasAccessBulkBarContainer;
